import { BiCheck } from 'react-icons/bi'
import { SiReact, SiFlutter, SiNodedotjs, SiAmazonaws } from 'react-icons/si'

const categories = [
  {
    title: 'Frontend Engineering',
    icon: SiReact,
    items: [
      'Architecting scalable React / Next.js applications with clean, reusable component systems.',
      'Advanced state management with Redux, Zustand and React Query for complex data flows.',
      'Performance tuning: code-splitting, lazy loading and Core Web Vitals optimization.',
      'Building accessible, responsive UIs with Tailwind CSS and design-system thinking.',
      'End-to-end and unit test coverage with Jest and React Testing Library.',
    ],
  },
  {
    title: 'Mobile Development',
    icon: SiFlutter,
    items: [
      'Cross-platform apps with React Native and Flutter, shipped to both App Store and Play Store.',
      'Native module integration for iOS (Swift) and Android (Kotlin) when performance demands it.',
      'Offline-first architecture, push notifications and deep linking.',
      'CI/CD pipelines for automated mobile builds, testing and store releases.',
    ],
  },
  {
    title: 'Backend & Architecture',
    icon: SiNodedotjs,
    items: [
      'Designing RESTful and GraphQL APIs built for scale, security and maintainability.',
      'Database architecture across PostgreSQL, MongoDB and Redis, tuned for performance.',
      'Authentication, authorization and role-based access control done right.',
      'Microservice and event-driven architecture for systems that need to grow.',
      'Technical documentation and API contracts that keep teams in sync.',
    ],
  },
  {
    title: 'Cloud & DevOps',
    icon: SiAmazonaws,
    items: [
      'Cloud infrastructure on AWS: EC2, S3, Lambda and RDS for production workloads.',
      'Containerization with Docker and orchestration with Kubernetes.',
      'CI/CD pipelines with GitHub Actions for automated testing and zero-downtime deploys.',
      'Monitoring, logging and incident response to keep systems reliable at scale.',
    ],
  },
]

const Services = () => {
  return (
    <section id='services'>
      <h5>What I offer</h5>
      <h2>Services</h2>

      <div className='container grid grid-cols-2 gap-8 max-[1024px]:grid-cols-1'>
        {categories.map(({ title, icon: Icon, items }) => (
          <article
            key={title}
            className='bg-bg-variant rounded-[2rem] border border-transparent transition hover:bg-transparent hover:border-primary-variant max-[1024px]:w-4/5 max-[1024px]:mx-auto max-[600px]:w-full'
          >
            <div className='flex items-center justify-center gap-3 bg-primary p-6 rounded-t-[2rem]'>
              <Icon className='text-bg text-xl' />
              <h3 className='text-bg text-base'>{title}</h3>
            </div>

            <ul className='p-6 flex flex-col gap-3'>
              {items.map((text) => (
                <li key={text} className='flex gap-3'>
                  <BiCheck className='text-primary text-lg mt-0.5 shrink-0' />
                  <p className='text-[0.9rem] text-light'>{text}</p>
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </section>
  )
}

export default Services
